import { flexRender, RowModel } from "@tanstack/react-table"
import { clsx } from "clsx"

interface Props<T> {
    rowModel: RowModel<T>
}

export function TBody<T>({ rowModel }: Props<T>) {
    return (
        <tbody className="divide-y divide-gray-200 bg-white dark:divide-zinc-700 dark:bg-zinc-900">
            {rowModel.rows.map((row) => {
                return (
                    <tr key={row.id}>
                        {row.getVisibleCells().map((cell) => {
                            return (
                                <td
                                    key={cell.id}
                                    className={clsx(
                                        "px-3 py-2",
                                        (cell.column.columnDef.meta as { className: string | undefined } | undefined)
                                            ?.className
                                    )}
                                >
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
        </tbody>
    )
}
